import { useState } from "react";
import { Dialog, DialogContent, DialogActions, Button, Typography, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "../../../components/icon";
import ScheduleAssessment from "screens/Requests/component/ScheduleAssessment";
import themeConfig from "components/configs/themeConfig";
import { useTheme } from "@mui/material/styles";



const AssessmentSuccessDialog = ({ 
  open, 
  onClose, 
  requestID, 
  setSchedulingReq, 
  setLoading, 
  scheduleStatus, 
  fetchRequests 
}) => {
  const [openScheduleDialog, setOpenScheduleDialog] = useState(false);
  const theme = useTheme();

  const handleClose = (action) => {
    if (action === "now") {
      // Close the success dialog and open the schedule dialog
      onClose("now");
      setOpenScheduleDialog(true);
    } else {
      // Just close the success dialog
      onClose(action);
    }
  };

  const handleCloseScheduleDialog = () => {
    setOpenScheduleDialog(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => handleClose("close")}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            textAlign: "center",
            width: '500px',
            p: 2,
            backgroundColor: theme.palette.mode === 'dark' ? '#1B2431'  : '#fff',
          }
        }}
      >
        {/* Close button */}
        <IconButton
          aria-label="close"
          onClick={() => handleClose("close")}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ pt: 6, pb: 2 }}>
          <Box display="flex" justifyContent="center" mb={2}>
            <Icon icon="eva:checkmark-circle-outline" width={40} height={40} color="#23A26D" />
          </Box>
          <Typography 
            variant="body1" 
            fontWeight="bold" 
            gutterBottom 
            sx={{ 
              fontSize: '1.5rem',
              mb: 2
            }}
          >
            Assessment 
          </Typography>
          <Typography 
            variant="body1" 
            color="text.secondary"
            sx={{ fontSize: "1rem", mb: 0 }}
          >
            Your assessment has been created. <br />
            Would you like to schedule it now or later?
          </Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button
            variant="outlined"
            color="main"
            onClick={() => handleClose("later")}
          >
            Schedule Later
          </Button>
          <Button
            variant="contained"
            color="main"
            onClick={() => handleClose("now")}
          >
            Schedule Now
          </Button>
        </DialogActions>
      </Dialog>

      {/* Schedule Assessment Dialog */}
      <ScheduleAssessment
        open={openScheduleDialog}
        handleClose={handleCloseScheduleDialog}
        entity="schedule"
        requestID={requestID}
        setSchedulingReq={setSchedulingReq}
        requestType={"Assessment"}
        setLoading={setLoading}
        scheduleStatus={scheduleStatus}
        fetchRequests={fetchRequests}
      />
    </>
  );
};

export default AssessmentSuccessDialog;